import api from '../../ApiConfig';
import { Apis } from '../../config';
var token = localStorage.getItem('userToken');
const getCurrencies = async () => {
  try {
    let result = await api.get(Apis.GetCurrencies, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const getSettings = async () => {
  try {
    let result = await api.get(Apis.GetSettings, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const updateVatSettings = async (data) => {
  try {
    let result = await api.post(Apis.UpdateVatSettings, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const getSeoPages = async()=>{
    try {
    let result = await api.get(Apis.GetSeoPages,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
}
const getSeoDetails = async (id) => {
  try {
    let result = await api.get(Apis.GetSeoDetails+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const updateSeoDetails = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateSeoDetails+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


//Shipping Zone

const getShippingZoneCountries = async () => {
  try {
    let result = await api.get(Apis.GetShippingZoneCountry,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const createShippingZoneCountry = async (data) => {
  try {
    let result = await api.post(Apis.CreateShippingZoneCountry, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const updateShippingZoneCountry = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateShippingZoneCountry+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const deleteShippingZoneCountry = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteShippingZoneCountry+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const getShippingRateLabels = async () => {
  try {
    let result = await api.get(Apis.GetShippingRateLabel,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const createShippingRateLabel = async (data) => {
  try {
    let result = await api.post(Apis.CreateShippingRateLabel, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const updateShippingRateLabel = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateShippingRateLabel+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const deleteShippingRateLabel = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteShippingRateLabel+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const getShippingZones = async () => {
  try {
    let result = await api.get(Apis.GetShippingZones,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};



const createShippingZone = async (data) => {
  try {
    let result = await api.post(Apis.CreateShippingZone, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const deleteShippingZone = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteShippingZone+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const updateShippingZone = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateShippingZone+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};



const getAllShippingZoneRates = async (data) => {
  try {
    let result = await api.get(Apis.GetAllShippingZoneRates,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const createShippingZoneRate = async (data) => {
  try {
    let result = await api.post(Apis.CreateShippingZoneRate, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const updateShippingZoneRate = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateShippingZoneRate+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const associateShippingZoneRates = async (data) => {
  try {
    let result = await api.post(Apis.AssociateShippingZoneRates, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const deleteShippingZoneRates = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteShippingZoneRates+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const deleteShippingZoneRate = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteShippingZoneRate+id,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const getShippingMethods = async (reqData) => {
    try{
        let result = await api.get(`${Apis.GetShippingMethods}?country_code=${reqData.country_code}&reason_code=${reqData.reason_code}&cart_price=${reqData.cart_price}`);
        return result.data;
    } catch (error) {
        return error.response.data;
    }

};

const exportedObject = {
    getCurrencies,
    getSettings,
    updateVatSettings,
    getSeoDetails,
    updateSeoDetails,
    getSeoPages,
    getShippingZoneCountries,
    createShippingZoneCountry,
    updateShippingZoneCountry,
    deleteShippingZoneCountry,
    getShippingRateLabels,
    createShippingRateLabel,
    updateShippingRateLabel,
    deleteShippingRateLabel,
    createShippingZone,
    getShippingZones,
    createShippingZoneRate,
    getAllShippingZoneRates,
    associateShippingZoneRates,
    deleteShippingZoneRates,
    updateShippingZoneRate,
    deleteShippingZone,
    updateShippingZone,
    deleteShippingZoneRate,
    getShippingMethods
};
export default exportedObject;